import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class Youtube extends ComponentBasePrototype {

  build() {
    this.video = null;
    this.column = null;
    this.videoMaxWidth = 0;
    this.videoHeight = 0;
    this.params = '';

    const hasTouch = document.documentElement.ontouchstart !== undefined;

    this.column = this.node.parent();
    this.player = this.node.find('.youtube__player');
    this.style = this.player.attr('data-style');
    this.rel = this.player.attr('data-rel');
    this.maxHeight = this.player.attr('data-height');

    const video = this.player.attr('data-video');
    const videoParts = video.split('?');

    this.id = videoParts[0];

    if (videoParts[1]) {
      this.params = videoParts[1];
    }

    const imageDiv = document.createElement('div');

    imageDiv.innerHTML = this.createYTThumbnail(this.id);
    this.player.append(imageDiv);

    if (hasTouch) {
      $(window).scroll((event) => {
        const element = $(event.currentTarget);
        const elementTop = this.node.offset().top;
        const elementHeight = this.node.outerHeight();
        const windowHeight = $(window).height();
        const windowScroll = element.scrollTop();

        if (windowScroll > (elementTop + (elementHeight - windowHeight))) {
          this.createYTiframe();
          this.video = this.node.find('#ytplayer');
          this.videoMaxWidth = this.video.innerWidth();
          this.videoHeight = this.video.innerHeight();
          this.onResize();
        }
      });
    } else {
      this.node.on('click', imageDiv, () => {
        this.createYTiframe();
        this.video = this.node.find('#ytplayer');
        this.videoMaxWidth = this.video.innerWidth();
        this.videoHeight = this.video.innerHeight();
        this.onResize();
      });
    }

    $(window).on('resize', () => {
      this.onResize();
    });

    this.image = this.node.find('.youtube__thumb');

    $(this.image).on('load', () => {
      this.onResize();
    });

    return true;
  }

  onResize() {
    this.imageMaxWidth = this.image.innerWidth();
    this.imageHeight = this.image.innerHeight();
    this.imageAspectRatio = this.imageHeight / this.imageMaxWidth;

    if (this.maxHeight < this.imageHeight) {
      this.imageHeight = this.maxHeight;
      this.imageMaxWidth = this.imageHeight / this.imageAspectRatio;
      this.imageOnloadMaxWidth = !this.imageOnloadMaxWidth ? this.imageMaxWidth : this.imageOnloadMaxWidth; //eslint-disable-line
    }

    const columnWidth = this.column.width();

    if (this.video) {
      if (columnWidth > this.imageOnloadMaxWidth) {
        this.resizeVideo(this.imageMaxWidth);
      } else {
        this.resizeVideo(columnWidth);
      }
    } else if (columnWidth > this.imageOnloadMaxWidth) {
      this.resizeImage(this.imageMaxWidth);
    } else {
      this.resizeImage(columnWidth);
    }
  }

  resizeContainer(newWidth) {
    this.node.width(newWidth);
    this.node.height(newWidth * this.imageAspectRatio);
  }

  resizeVideo(newWidth) {
    this.video.width(newWidth);
    this.video.height(newWidth * this.imageAspectRatio);
    this.resizeContainer(newWidth);
  }

  resizeImage(newWidth) {
    this.image.width(newWidth);
    this.image.height(newWidth * this.imageAspectRatio);
    this.resizeContainer(newWidth);
  }

  // TODO: This makes assumptions on what kind of thumbnails should be shown based on the height parameter the editors provide in the dialog.
  // Youtube generates these thumbnails based on the resolution of the video and has nothing to do with the height of this component.
  // So if one uploads a low resolution video and tells the component to be over 400px high, there will probably not be a "maxresdefault.jpg" available.
  createYTThumbnail(id) {
    let imageType = '/hqdefault.jpg';

    if (this.maxHeight > 400) {
      imageType = '/maxresdefault.jpg';
    }

    return `<img class="youtube__thumb" src="//img.youtube.com/vi/${id}${imageType}" alt=""><div class="youtube__play-button"></div>`;
  }

  createYTiframe() {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube.com/embed/${this.id}?${this.params}&autoplay=1&rel=${this.rel}&origin=https://sonera.fi&enablejsapi=1`);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '1');
    iframe.setAttribute('id', 'ytplayer');
    iframe.setAttribute('style', this.style);
    this.player.replaceWith(iframe);
  }
}
